// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2oie2","alertIcon":"ConfirmModal_alertIcon__2oXzq"};